import { render, staticRenderFns } from "./amend.vue?vue&type=template&id=020be1c8&scoped=true&"
import script from "./amend.vue?vue&type=script&lang=js&"
export * from "./amend.vue?vue&type=script&lang=js&"
import style0 from "./amend.vue?vue&type=style&index=0&id=020be1c8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020be1c8",
  null
  
)

export default component.exports